import { FC, useState, useCallback } from "react";
import { Grid } from "@giphy/react-components";
import { GiphyFetch } from "@giphy/js-fetch-api";
import { IGif } from "@giphy/js-types";
import { Input } from "@src/lib/ui/Input";

const gf = new GiphyFetch(process.env.NEXT_PUBLIC_GIPHY_API_KEY ?? "");

type Props = {
  onGIFSelect: (gif: IGif) => void;
};

const GIFs: FC<Props> = (props) => {
  const [searchTerm, setSearchTerm] = useState("");

  const fetchGifs = useCallback(
    (offset: number) => {
      if (searchTerm) {
        return gf.search(searchTerm, { offset, limit: 50 });
      }
      return gf.trending({ offset, limit: 50 });
    },
    [searchTerm],
  );

  return (
    <div className="flex h-full w-[490px] min-w-[490px] flex-col gap-2">
      <Input
        placeholder="Search GIFs from Giphy"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className="w-[473px]"
      />
      <div className="h-full w-[473px] overflow-x-hidden overflow-y-auto">
        <Grid
          key={searchTerm}
          width={473}
          columns={3}
          gutter={10}
          fetchGifs={fetchGifs}
          onGifClick={(gif, e) => {
            e.preventDefault();
            props.onGIFSelect(gif);
          }}
        />
      </div>
    </div>
  );
};

export default GIFs;
